import Config from "../../config/Config";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlRecitationDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};

export const getDataRecitation = (query = []) => {
     return new Promise((resolve, reject) => {
        axios
          .get(`${baseUrlDev}setoran/open/all?${query.join("&")}`, {
            headers: {
              Authorization: `Bearer ${bearer()}`,
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
}

export const getSummaryRecitation = (query = []) => {
     return new Promise((resolve, reject) => {
        axios
          .get(`${baseUrlDev}setoran/open/summary?${query.join("&")}`, {
            headers: {
              Authorization: `Bearer ${bearer()}`,
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
}
export const getTypeRecitation = (companyId) => {
     return new Promise((resolve, reject) => {
        axios
          .get(`${baseUrlDev}setoran/open?company_id=${companyId}`, {
            headers: {
              Authorization: `Bearer ${bearer()}`,
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
}
export const getSubTypeRecitation = (id) => {
     return new Promise((resolve, reject) => {
        axios
          .get(`${baseUrlDev}open/tipe_hafalan_combo/sub_type/${id}`, {
            headers: {
              Authorization: `Bearer ${bearer()}`,
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
}

// Recitation Report
export const getDataRecitationRecap = (query = []) => {
     return new Promise((resolve, reject) => {
        axios
          .get(`${baseUrlDev}open/all?${query.join("&")}`, {
            headers: {
              Authorization: `Bearer ${bearer()}`,
            },
          })
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
}